/**
 * The picker options represents an array of PickerOptionsSection (each connected account has an array of selected calendars)
 */
export interface PickerOptionsSection {
    account: string;
    isPrimaryAccount: boolean;
    leafOptions: PickerOption[];
    parentOptions: ParentOption[];
}

export interface PickerOption {
    id: string;
    parentId?: string;
    index: number;
    displayName: string;
    account: string;
    isShown: boolean;
}

export interface ParentOption extends PickerOption {
    isExpanded: boolean;
    isFavorite: boolean;
    children: PickerOption[];
}

export function isParentOption(option: PickerOption) {
    const parentOption = option as ParentOption;

    if (!parentOption) {
        return false;
    }

    return parentOption.children !== undefined;
}
